export default __webpack_public_path__ + "img/f59555a1ba8d0695c1b81284ba53b8f5.svg";